import { API_BASE_URL } from '../consts';

export default {
	baseURL: API_BASE_URL,
	headers: {
		'X-Requested-With': 'XMLHttpRequest'
	}
	//withCredentials: true
};



// WEBPACK FOOTER //
// ./src/config/http/api.js